import {DataSource} from '@angular/cdk/collections';
import {MatPaginator,MatSort} from '@angular/material';
import {Observable} from 'rxjs/Observable';

export class DataSourceGrid extends DataSource<any> {
  constructor(private result, private _paginator: MatPaginator, public _sort: MatSort) {
    super();
  }

  connect(): Observable<any[]> {
    const displayDataChanges = [
      this.result,
      this._sort.sortChange,
      this._paginator.page,
    ];

    return Observable.merge(...displayDataChanges).map(() => {
      const data = this.result.slice();
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      const sortedData = this.sortData(data.slice());
      return sortedData.splice(startIndex, this._paginator.pageSize);
    });
  }

  disconnect() {}

  sortData(data: any[]): any[] {
    if (!this._sort.active || this._sort.direction == '') { return data; }
    return data.sort((a, b) => {
      let propertyA: number|string = '';
      let propertyB: number|string = '';
      [propertyA, propertyB] = [a[this._sort.active], b[this._sort.active]];
      let valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      let valueB = isNaN(+propertyB) ? propertyB : +propertyB;
      return (valueA < valueB ? -1 : 1) * (this._sort.direction == 'asc' ? 1 : -1);
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/utils/data-source-grid.component.ts